module.exports = __webpack_public_path__ + "img/img-72.f62303bc.png";